import { getMarginBottom } from "components/common/inputScales";
import { createThemedUseStylesWithParams } from "theme";

import { Header1Props } from "./Header1Types";

export default createThemedUseStylesWithParams<Header1Props>(
  (params, theme) => ({
    h1: {
      marginTop: 0,
      marginLeft: 0,
      marginRight: 0,
      marginBottom: getMarginBottom(params.stackSpacing, theme)
    }
  })
);
